/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from 'ng2-semantic-ui/components/transition/transition';
import * as i3 from './popup-arrow.ngfactory';
import * as i4 from 'ng2-semantic-ui/components/popup/popup-arrow';
import * as i5 from 'ng2-semantic-ui/components/popup/popup';
const styles_SuiPopup:any[] = ['.ui.popup[_ngcontent-%COMP%] {\n    right: auto;\n}\n\n.ui.animating.popup[_ngcontent-%COMP%] {\n    \n    pointer-events: none;\n}\n\n.ui.popup[_ngcontent-%COMP%]::before {\n    display: none;\n}\n\n.ui.popup[direction="top"][_ngcontent-%COMP%], .ui.popup[direction="bottom"][_ngcontent-%COMP%] {\n    margin-top: 1em;\n    margin-bottom: 1em;\n}\n\n.ui.popup[direction="left"][_ngcontent-%COMP%], .ui.popup[direction="right"][_ngcontent-%COMP%] {\n    margin-left: 1em;\n    margin-right: 1em;\n}'];
export const RenderType_SuiPopup:i0.RendererType2 = i0.ɵcrt({encapsulation:0,styles:styles_SuiPopup,
    data:{}});
function View_SuiPopup_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'div',[['class',
      'header']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(1,(null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.config.header;
    _ck(_v,1,0,currVal_0);
  });
}
function View_SuiPopup_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),7,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['\n        '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_SuiPopup_2)),i0.ɵdid(3,16384,(null as any),
          0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n        '])),(_l()(),i0.ɵeld(5,0,(null as any),
          (null as any),1,'div',[['class','content']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵted(6,(null as any),
          ['',''])),(_l()(),i0.ɵted(-1,(null as any),['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.config.header;
    _ck(_v,3,0,currVal_0);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.config.text;
    _ck(_v,6,0,currVal_1);
  });
}
export function View_SuiPopup_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(402653184,1,{_container:0}),i0.ɵqud(402653184,2,{_templateSibling:0}),
      (_l()(),i0.ɵted(-1,(null as any),['\n'])),(_l()(),i0.ɵeld(3,16777216,[[1,3],
          ['container',1]],(null as any),10,'div',[['class','ui popup']],[[2,'inverted',
          (null as any)],[2,'basic',(null as any)],[1,'direction',0],[2,'transition',
          (null as any)],[2,'visible',(null as any)],[2,'hidden',(null as any)]],(null as any),
          (null as any),(null as any),(null as any))),i0.ɵdid(4,16384,(null as any),
          0,i2.SuiTransition,[i0.Renderer,i0.ElementRef,i0.ChangeDetectorRef],{suiTransition:[0,
              'suiTransition']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SuiPopup_1)),
      i0.ɵdid(7,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i0.ɵeld(9,16777216,[[2,3],['templateSibling',1]],(null as any),0,'div',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵeld(11,0,(null as any),
          (null as any),1,'sui-popup-arrow',([] as any[]),[[2,'inverted',(null as any)]],
          (null as any),(null as any),i3.View_SuiPopupArrow_0,i3.RenderType_SuiPopupArrow)),
      i0.ɵdid(12,49152,(null as any),0,i4.SuiPopupArrow,([] as any[]),{position:[0,
          'position'],inverted:[1,'inverted'],basic:[2,'basic']},(null as any)),(_l()(),
          i0.ɵted(-1,(null as any),['\n'])),(_l()(),i0.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        var _co:i5.SuiPopup = _v.component;
        const currVal_6:any = _co.transitionController;
        _ck(_v,4,0,currVal_6);
        const currVal_7:boolean = !_co.config.template;
        _ck(_v,7,0,currVal_7);
        const currVal_9:any = _co.position;
        const currVal_10:any = _co.config.inverted;
        const currVal_11:any = _co.config.basic;
        _ck(_v,12,0,currVal_9,currVal_10,currVal_11);
      },(_ck,_v) => {
        var _co:i5.SuiPopup = _v.component;
        const currVal_0:any = _co.config.inverted;
        const currVal_1:any = _co.config.basic;
        const currVal_2:any = _co.direction;
        const currVal_3:any = i0.ɵnov(_v,4).transitionClass;
        const currVal_4:any = i0.ɵnov(_v,4).isVisible;
        const currVal_5:any = i0.ɵnov(_v,4).isHidden;
        _ck(_v,3,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
        const currVal_8:any = i0.ɵnov(_v,12).inverted;
        _ck(_v,11,0,currVal_8);
      });
}
export function View_SuiPopup_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'sui-popup',
      ([] as any[]),(null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onClick($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_SuiPopup_0,RenderType_SuiPopup)),i0.ɵdid(1,49152,(null as any),0,i5.SuiPopup,
      [i0.ElementRef],(null as any),(null as any))],(null as any),(null as any));
}
export const SuiPopupNgFactory:i0.ComponentFactory<i5.SuiPopup> = i0.ɵccf('sui-popup',
    i5.SuiPopup,View_SuiPopup_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/node_modules/ng2-semantic-ui/components/popup/popup.ngfactory.ts